/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tournament_Unranked_Reason_StorylineInputs */



/**
* | output |
* | --- |
* | "Storyline format" |
*
* @param {Tournament_Unranked_Reason_StorylineInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const tournament_unranked_reason_storyline = /** @type {((inputs?: Tournament_Unranked_Reason_StorylineInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tournament_Unranked_Reason_StorylineInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("format Storyline")
	if (locale === "es") return /** @type {LocalizedString} */ ("formato Storyline")
	if (locale === "pt") return /** @type {LocalizedString} */ ("formato Storyline")
	if (locale === "it") return /** @type {LocalizedString} */ ("formato Storyline")
	return /** @type {LocalizedString} */ ("Storyline format")
});